import { useEffect, useRef, useState, type SyntheticEvent } from 'react';

// Videos over 40 MB have their playable copy and cover made by Cloudinary in
// the background for a few minutes after upload (DECISIONS "Videos: no time
// limit, up to 100 MB"); until then the address fails. This tries again
// every 10 seconds for up to 5 minutes and says the video is getting ready.
const WAIT_MS = 10_000;
const TRIES = 30;

export function useProcessingRetry() {
  const [preparing, setPreparing] = useState(false);
  const tries = useRef(0);
  const timer = useRef<number | undefined>(undefined);
  useEffect(() => () => window.clearTimeout(timer.current), []);
  function onError(event: SyntheticEvent<HTMLVideoElement | HTMLImageElement>) {
    const target = event.currentTarget;
    if (tries.current >= TRIES) { setPreparing(false); return; }
    tries.current += 1;
    setPreparing(true);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => {
      if (target instanceof HTMLVideoElement) { target.load(); return; }
      const url = new URL(target.src);
      url.searchParams.set('try', String(tries.current));
      target.src = url.href;
    }, WAIT_MS);
  }
  function onReady() {
    tries.current = 0;
    setPreparing(false);
  }
  return { preparing, onError, onReady };
}
